import React from 'react';
import PropTypes from 'prop-types';
import { keys } from 'lodash';
import { Table, OverlayTrigger, Popover, Button } from 'react-bootstrap';
import ConditionalComponent from './ConditionalComponent';

const getPopover = (title, tags) => (
  <Popover
    id="popover-tags-bottom"
    title={title}
    data-html
  >
    <div>
      {tags.split('\n').map((t, i) => <p key={i}>{t}</p>)}
    </div>
  </Popover>
);


const AWSInstancesComponent = ({ instances, onSort }) => (
  <div>
    <Table striped bordered className="aws-table">
      <thead>
        <tr>
          <th onClick={() => onSort('yesterday')}>Yesterday</th>
          <th onClick={() => onSort('today')}>Today</th>
          <th onClick={() => onSort('tomorrow')}>Tomorrow</th>
          <th onClick={() => onSort('annualized')}>
            Annualized(ystd*365)</th>
          <th onClick={() => onSort('id')}>Instance Id</th>
          <th onClick={() => onSort('name')}>Name</th>
          <th onClick={() => onSort('instanceType')}>
            Instance Type</th>
          <th onClick={() => onSort('owner')}>Owner</th>
          <th onClick={() => onSort('account')}>Account</th>
          <th onClick={() => onSort('region')}>Region</th>
          <th> Best Before</th>
          <th>Other Tags</th>
        </tr>
      </thead>
      <tbody>
        {
          keys(instances).map((key) => instances[key].map(a => (
            <tr key={a.id}>
              <td>
                {a.yesterday}
              </td>
              <td>{a.today}</td>
              <td>{a.tomorrow}</td>
              <td>{a.annualized}</td>
              <td>{a.id}</td>
              {a.name.includes('Requires Name Tag') ?
                <td className="text-center-highlighted">
                  {a.name}
                </td> :
                <td>{a.name}</td>}
              <td>
                {a.instanceType}
              </td>
              <td>{a.owner}</td>
              <td>{a.account}</td>
              <td>{a.region}</td>
              <td>
                {a.bestBefore}
              </td>
              <td>
                <ConditionalComponent condition={a.otherTags !== ''}>
                  <OverlayTrigger
                    trigger="click"
                    rootClose
                    overlay=
                      {getPopover('Other tags', a.otherTags)}
                  >
                    <Button className="tag-button" />
                  </OverlayTrigger>
                </ConditionalComponent>
              </td>
            </tr>
          )))
        }
      </tbody>
    </Table>
  </div>
);

AWSInstancesComponent.propTypes =
 {
   instances:
    PropTypes.objectOf(PropTypes.arrayOf(Object)).isRequired,
   onSort:
    PropTypes.func.isRequired
 };

export default AWSInstancesComponent;


// WEBPACK FOOTER //
// src/Components/AWSInstancesTableComponent.jsx